<div class="navbar-wrapper">
  <div class="logo-container">
    <img src="assets/img/start-page/HVB_Logo.svg" class="cursor-pointer" alt="HVB Logo"/>
  </div>
</div>
<div class="main-outer-div flex-grow-1 flex-shrink-1 pt-4">
  <div class="left form-title-section-text">
    <h1>{{ 'createCompany.createCompanyTitle' | translate: {companyGroup: company.name} }}</h1>
    <h4>{{ 'createCompany.createCompanySubtitle' | translate }}</h4>
  </div>
  <div class="d-flex justify-content-between align-items-end form-title-section-buttons">
    <button (click)="logout()" class="menu-button me-4 w-50 flex-shrink-1">
      {{'loginPage.logout'|translate}}
    </button>
    <button [disabled]="!(allFormsValid$|async) || saveCompanyButtonDisabled"
            (click)="openConfirmationMatDialog()"
            data-cy="company-button"
            class="menu-button save-button w-50 flex-shrink-1"
            id="publishProposal">{{'createCompany.createCompany'|translate}}</button>
  </div>
  <div #buttons class="left">
    <div class="white-box">
      <div class="form-steps-container-title">
        <div class="form-steps-title-section-row-1">
          <div class="form-steps-title-section-left">
            <div class="section-title" style="margin-right: 10px">
              {{'formStepsSection.title'|translate}}
            </div>
          </div>
        </div>

      </div>

      <div class="d-flex flex-column " style="float: right; width: 100%">

        <ng-container *ngFor="let title of titles;let i = index">
          <ng-container>
            <div (click)="scroll(idNames[i])" [id]="idNames[i]+'button'"
                 [ngClass]="{'selectedSection': scrolled == i}"
                 class="form-steps-list-row">

              <div class="form-steps-list-row-error-non-visible"
                   [ngClass]="{'form-steps-list-row-error': !(validChildForm[i] | async)&& i < maxScrolled && scrolled!= i}">
                <div class=" form-steps-list-items">
                  <ng-container>
                    <ng-container *ngIf="(validChildForm[i] | async) && maxScrolled > i">
                      <ng-container *ngTemplateOutlet="validCircle"></ng-container>
                    </ng-container>

                    <ng-container
                      *ngIf="!(validChildForm[i] | async) && i < maxScrolled">
                      <ng-container *ngTemplateOutlet="errorIcon"></ng-container>
                    </ng-container>

                    <ng-container
                      *ngIf="i >= maxScrolled && i !== scrolled">
                      <ng-container *ngTemplateOutlet="emptyCircle"></ng-container>
                    </ng-container>

                    <ng-container
                      *ngIf="(validChildForm[i] | async) && i === scrolled && i >= maxScrolled">
                      <ng-container *ngTemplateOutlet="selectedCircle"></ng-container>
                    </ng-container>


                    <ng-container
                      *ngIf="!(validChildForm[i] | async) && scrolled === i && maxScrolled === i">
                      <ng-container *ngTemplateOutlet="selectedCircle"></ng-container>
                    </ng-container>

                  </ng-container>
                  <span class="progress-bar-text">
                        {{(i + 1) + '/2'}}
                    {{'createCompany.' + title|translate}}
                  </span>
                </div>
              </div>

            </div>
            <div *ngIf="titles[i+1] !== undefined" class="vertical-line"></div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>


  <div #rightPart id="rightPart" class="right" (scroll)="onWindowScroll(rightPart)">
    <div [id]="idNames[0]" class="form-inner-container">
      <app-address-information-company-form></app-address-information-company-form>
      <hr>
    </div>

    <div [id]="idNames[1]" class="form-inner-container margin-bottom-xxl">
      <app-contact-information-company-form></app-contact-information-company-form>
      <div class="next-button-container">
        <button [disabled]="!(allFormsValid$|async) || saveCompanyButtonDisabled" (click)="openConfirmationMatDialog()"
                class="menu-button save-button">{{'createCompany.createCompany'|translate}}</button>
      </div>
    </div>
  </div>
</div>

<ng-template #validCircle><span class="circle-valid">
  <mat-icon>done</mat-icon>
                  </span>
</ng-template>
<ng-template #invalidCircleSelected><span class="invalid-un-selected">
  <mat-icon>
warning
</mat-icon>
                  </span>
</ng-template>

<ng-template #errorIcon><span class="invalid-selected">
  <img alt="warning" src="assets/svg-icons/warning_amber.svg"> </span>
</ng-template>
<ng-template #emptyCircle><span class="circle">
                  </span></ng-template>

<ng-template #selectedCircle><span class="circle selected-circle">
                  </span></ng-template>
